export default __webpack_public_path__ + "static/media/Mockup1.ccf1058d.png";